import {getApiUrl, getClientId, getAppInsightsConnectionString, getEnvName} from "./utils";

export const API_URL = getApiUrl();
export const CLIENT_ID = getClientId();
export const APP_INSIGHTS_CONNECTION_STRING =  getAppInsightsConnectionString();
export const ENV_NAME = getEnvName();
export const NO_DOC_MANAGEMENT = "No document management";
